import { ViewEmployee } from '../models'

export const copyEmployee = (employee: ViewEmployee): Omit<ViewEmployee, 'id'> => {
  const copyEmployee: ViewEmployee = {
    ...employee,
    name: `${employee.name} (Kopie)`,
    info: { ...employee.info },
    settings: { ...employee.settings },
    workingHours: employee.workingHours?.map((workingHour) => ({
      ...workingHour,
      weekdays: [...workingHour.weekdays],
    })),
    services: employee.services?.map((service) => ({ ...service })) ?? [],
  }
  return copyEmployee
}
